module.exports = __webpack_public_path__ + "static/media/payment-type.852c23d5.svg";